const c = (t) => {
  try {
    const o = new URL(t), n = o.protocol === "http:" || o.protocol === "https:" || o.protocol === "ftp:", r = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(o.hostname);
    return n && r;
  } catch {
    return !1;
  }
};
export {
  c as isUrl
};
